// 设备管理接口
import request from '@/utils/request'

// export const getinjurylist = (params: any) =>
//   request({
//     url: '/api/injuryManage',
//     method: 'get',
//     params
//   })
export const getinjurylist = (params: any) =>
  request({
    url: '/injurydetails/getlistbycondition',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const addinjurylist = (params: any) =>
//   request({
//     url: '/api/injuryManage',
//     method: 'post',
//     data: params,
//   })
export const addinjurylist = (params: any) =>
  request({
    url: '/injurydetails/addInjury',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })


// export const getinjuryInfo = (params: any) =>
//   request({
//     url: `/api/injuryManage/:id`,
//     params
//   })
export const getinjuryInfo = (params: any) =>
  request({
    url: `/injurydetails/getInjuryInfoById`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

// export const editinfo = (params: any) =>
//   request({
//     url: `/api/getinjuryInfo`,
//     method: 'put',
//     data: params
//   })
export const editinfo = (params: any) =>
  request({
    url: `/injurydetails/updateInJuryInfo`,
    method: 'put',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const handleupfile = (params: any) =>
  request({
    url: `/injurydetails/uploadfile`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })